export const GET_CONFIG = 'GET_CONFIG';
export const MUSIC_SEARCH = 'music_search';
export const SEARCH_INPUT = 'search_input';
export const SEARCH_RESULTS = 'search_results';
export const CURRENT_TRACK = 'current_track';
export const ADVANCED_TRACK = 'advanced_track';
export const SEARCH_RESULTS_ADVANCED = 'search_results_advanced';
export const SEARCH_RESULTS_ADVANCED_START = 'SEARCH_RESULTS_ADVANCED_START';
export const AUTH_INPUT = 'auth_reducer';
export const SIGNUP_USERNAME_PASS = 'signup_username_pass';
export const LOGIN_USERNAME_PASS = 'login_username_pass';
export const AUTH_LOGOUT = 'auth_logout';
export const FACEBOOOK_AUTH = 'facebook_auth';
export const USER_DATA_FROM_FIRESTORE = 'user_data_from_firestore';
export const FIREBASE_LOGIN = 'firebase_login';
export const PASSWORD_RESET_EMAIL_SENT = 'password_reset_email_sent';
export const CHANGE_LOGIN_EMAIL_SENT = 'change_login_email_sent';
export const UPDATE_USER_EMAIL = 'update_user_email';
export const FILTER_OPTIONS = 'filter_options';
export const SET_PLAYING_TRACK = 'set_playing_track';
export const IS_PLAYING = 'is_playing';
export const UPDATE_AUDIO_STATE = 'update_audio_state';
export const UPDATE_USERNAME = 'update_username';
export const RESET_SEARCH = 'reset_search';
export const CLEAR_ADVANCED_TRACK_DATA = 'clear_advanced_track_data';
export const PERFORMING_BASIC_SEARCH = 'performing_basic_search';
export const HOME_SEARCH_RESULT = 'home_search_result';
export const FOOTER_IS_PAUSED = 'footer_is_paused';
export const RESET_AUTH_FIELDS = 'reset_auth_fields';
export const MODAL_IS_OPEN = 'modal_is_open';
export const SEARCH_PERFORMED = 'search_performed';
export const SHOW_ADVANCED_DATA = 'show_advanced_data';


// WEBPACK FOOTER //
// ./src/store/constants/action-types.js